class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

/* Miss Color: desktop hover-menu
   Opent de uitklapmenu's in de desktop-navigatie zodra de muis erop komt.
   Alleen actief op desktop met een echte muis; touch/mobiel blijft klikken. */
(function () {
  const NAV = '.header__inline-menu';
  const CLOSE_DELAY = 150;

  const desktopQuery = window.matchMedia('(min-width: 990px)');
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  let closeTimer = null;

  function hoverEnabled() {
    return desktopQuery.matches && hoverQuery.matches;
  }

  function openDetails(details) {
    if (!details || details.hasAttribute('open')) return;
    details.setAttribute('open', '');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDetails(details) {
    if (!details || !details.hasAttribute('open')) return;
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function closeAll(keepOpen) {
    document.querySelectorAll(`${NAV} details[open]`).forEach((details) => {
      if (keepOpen && (details === keepOpen || details.contains(keepOpen))) return;
      closeDetails(details);
    });
  }

  document.addEventListener('mouseover', (event) => {
    if (!hoverEnabled()) return;
    const target = event.target;
    if (!(target instanceof Element) || !target.closest(NAV)) return;

    clearTimeout(closeTimer);

    const details = target.closest(`${NAV} details`);
    closeAll(details);
    if (!details) return;

    openDetails(details);

    let parent = details.parentElement && details.parentElement.closest(`${NAV} details`);
    while (parent) {
      openDetails(parent);
      parent = parent.parentElement && parent.parentElement.closest(`${NAV} details`);
    }
  });

  document.addEventListener('mouseout', (event) => {
    if (!hoverEnabled()) return;
    const target = event.target;
    if (!(target instanceof Element) || !target.closest(NAV)) return;

    const related = event.relatedTarget;
    if (related instanceof Element && related.closest(NAV)) return;

    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => closeAll(null), CLOSE_DELAY);
  });

  // Een klik op een al geopend menu mag het niet meteen weer dichtklappen.
  document.addEventListener('click', (event) => {
    if (!hoverEnabled()) return;
    if (event.detail === 0) return; // toetsenbord (Enter/Space) normaal laten werken
    const target = event.target;
    if (!(target instanceof Element)) return;
    const summary = target.closest(`${NAV} summary`);
    if (!summary) return;
    const details = summary.parentElement;
    if (details && details.hasAttribute('open')) event.preventDefault();
  });
})();
